
import { cn } from "@/lib/utils";
import type { FunnelData, ColorScheme } from "../types";
import { LOGO_ICONS } from "../constants";
import { LOGO_FONTS } from "../TabContent/LogoMaker/constants";

interface LogoDisplayProps {
  data: FunnelData;
  colors: ColorScheme;
  className?: string;
}

export const LogoDisplay = ({ data, colors, className }: LogoDisplayProps) => {
  // Get logo icon component if configured
  const LogoIcon = data.logoConfig?.icon && LOGO_ICONS.find(
    icon => icon.label === data.logoConfig?.icon
  )?.icon;

  const selectedFont = LOGO_FONTS.find(f => f.value === data.logoConfig?.font);

  return (
    <div className={cn("h-8 w-28 flex items-center", className)}>
      {data.logo ? (
        <img 
          src={data.logo} 
          alt={data.siteName} 
          className="h-8 w-28 object-contain"
        />
      ) : (
        <div className="flex items-center gap-2">
          {LogoIcon && (
            <LogoIcon 
              className="w-6 h-6"
              style={{ color: data.logoConfig?.iconColor || data.logoConfig?.color || colors.primary }}
            />
          )}
          <span 
            className={cn(
              data.logoConfig?.fontSize || 'text-xl',
              data.logoConfig?.fontWeight || 'font-normal',
              selectedFont?.className
            )}
            style={{ 
              color: data.logoConfig?.color || colors.primary,
              background: data.logoConfig?.color?.includes('gradient') ? data.logoConfig.color : undefined,
              WebkitBackgroundClip: data.logoConfig?.color?.includes('gradient') ? 'text' : undefined,
              WebkitTextFillColor: data.logoConfig?.color?.includes('gradient') ? 'transparent' : undefined,
            }}
          >
            {data.siteName}
          </span>
        </div>
      )}
    </div>
  );
};
